import { DeviceConnections } from '@/features/controller/configuration/components/tree/DeviceConnections'
import type {
  ControllerConfigurationModel,
  ControllerConfigurationModelUpdate,
} from '@/features/controller/configuration/models/controllerConfiguration'

interface ControllerConfigurationTreeProps {
  configuration: ControllerConfigurationModel
  indent: boolean
  onConfigurationUpdated: (configurationUpdate: ControllerConfigurationModelUpdate) => void
}

/**
 * Encapsulates the editing UI for controller configuration without tying it to a specific controller.
 *
 * Currently, this includes only one component DeviceConnections but this is likely to change.
 */
export function ControllerConfigurationTree({
  configuration,
  indent,
  onConfigurationUpdated,
}: Readonly<ControllerConfigurationTreeProps>) {
  return (
    <DeviceConnections configuration={configuration} indent={indent} onConfigurationUpdated={onConfigurationUpdated} />
  )
}
